module.exports = __webpack_public_path__ + "static/media/settings.684fcc9b.svg";